export const treatmentMetaFields = [
    {
        name: `Item`,
        field: `itemName`,
        check: `required`,
    },
    {
        name: `Item selected`,
        field: `itemID`,
        check: `required`,
    },
    {
        name: `Prescription`,
        field: `prescriptionDosageRouteDuration`,
        check: `required`,
    },
];

export const appointmentMetaFields = [
    {
        name: `Doctor`,
        field: `doctor`,
        check: `required`,
    },
    {
        name: `Clinic`,
        field: `clinic`,
        check: `required`,
    },
    {
        name: `Date`,
        field: `appointmentDate`,
        check: `required`,
    },
    {
        name: `Time`,
        field: `time`,
        check: `required`,
    },
];
